import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { SubTabs } from 'shared/components';
import COD_PARCEL_STATUS_QUERY, { CodParcelStatusData } from 'shared/graphql/query/codParcelStatus';
import { CodParcelStatus } from 'views/CashOnDelivery/Routes/CashOnDeliveryByParcel/common/model/codParcelStatus.model';

interface CodLastTabsProps {
  name: string;
  tab: CodParcelStatus;
  onChange: (tab: CodParcelStatus) => void;
}

const CodRejectTabs: React.FC<CodLastTabsProps> = (props) => {
  const { tab, onChange, name } = props;
  const { data, refetch } = useQuery<CodParcelStatusData>(COD_PARCEL_STATUS_QUERY, {
    fetchPolicy: 'cache-and-network',
  });

  const checkSelectTab = (id: CodParcelStatus) => {
    return id === tab && name === 'cod';
  };

  const selectTab = (index: CodParcelStatus) => {
    refetch();
    onChange(index);
  };

  const tabs = [
    {
      id: CodParcelStatus.REJECT,
      name: 'ปฎิเสธ',
      color: 'badge-grey',
      count: data?.codParcelStatus.reject || 0,
      divider: false,
    },
  ].map((item) => ({
    id: item.id,
    name: item.name,
    count: item.count,
    active: checkSelectTab(item.id),
    clicked: () => selectTab(item.id),
    badgeClassName: checkSelectTab(item.id) ? item.color : null,
    divider: item.divider,
  }));

  return <SubTabs tabs={tabs} />;
};

export default CodRejectTabs;
